import { z } from "zod";

export const USER_AUTH_TYPE_VALUES = {
  PASSWORD: "password",
  GOOGLE: "google",
} as const;

export const UserAuthTypeSchema = z.enum(USER_AUTH_TYPE_VALUES);

export type UserAuthType = z.infer<typeof UserAuthTypeSchema>;

export const UserAuthType = {
  ...USER_AUTH_TYPE_VALUES,
} as const;
